import { Injectable } from '@angular/core';

import { motoristasStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";

@Injectable()
export class MotoristaService {

  constructor(
    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(motoristasStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(motoristasStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(motoristasStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
  }

  templateResult = (function(state: any, isCreateNew: boolean) {
    var stateReturn: any,
      text: string;

    if (state.loading) {
      stateReturn = state.text;
    } else {
      if (state.id === -1) {
        if (isCreateNew) {
          stateReturn = this._autocompleteService.setNewTagInList(state);
        } else {
          stateReturn = this._autocompleteService.setNoCreateNew(state.text);
        }
      } else {
        if (state.text) {
          text = state.text;
        } else {
          var name: string;
          if (state.funcionario) {
            if (state.funcionario.pessoa) {
              name = state.funcionario.pessoa.nome;
            }
          }

          text = name;
        }
        stateReturn = $('<span>' + text + '</span>');
      }
    }

    return stateReturn;
  }.bind(this));
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/motoristas/shared/motorista.service.ts
 **/